<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
          absolute
      offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <!-- Texto clickable, no input -->
      <div
        v-bind="attrs"
        v-on="on"
        class="periodo-texto"
        style="cursor: pointer; user-select: none"
      >
        <strong class="text-h6" v-if="localFechaPeriodo">{{
          formattedFechaPeriodo
        }}</strong>
        <em v-else>Seleccionar mes y año</em>
        <v-icon class="ml-1">mdi-menu-down</v-icon>
      </div>
    </template>

    <v-date-picker
      v-model="localFechaPeriodo"
      type="month"
      locale="es"
      no-title
      year-icon="mdi-calendar-blank"
      prev-icon="mdi-skip-previous"
      next-icon="mdi-skip-next"
      @input="onInput"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "FechaPeriodoVFilter",
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      menu: false,
      localFechaPeriodo: this.value || this.getTodayPeriod(),
    };
  },
  computed: {
    formattedFechaPeriodo() {
      if (!this.localFechaPeriodo) return "";
      const mes = this.moment(this.localFechaPeriodo, "YYYY-MM").format("MMMM");
      const año = this.moment(this.localFechaPeriodo, "YYYY-MM").format("YYYY");
      // Capitalizar primera letra del mes
      const mesCapitalizado = mes.charAt(0).toUpperCase() + mes.slice(1);
      return `${mesCapitalizado} ${año}`;
    },
  },
  watch: {
    value(newVal) {
      this.localFechaPeriodo = newVal;
    },
  },
  methods: {
    onInput(value) {
      this.localFechaPeriodo = value;
      this.$emit("input", value);
      this.menu = false; // cerrar menú al seleccionar
    },
    removePeriodo() {
      this.localFechaPeriodo = null;
      this.$emit("input", null);
    },
    getTodayPeriod() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      return `${year}-${month}`;
    },
  },
};
</script>
